import HTTP from './index';

export const fetchMaturityTypes = () => HTTP.get("/commons/maturityTypes");

